export const MOBILE_BREAKPOINT = 768;

let reducedMotionQuery: MediaQueryList | undefined;

export function prefersReducedMotion() {
  reducedMotionQuery ??= window.matchMedia('(prefers-reduced-motion: reduce)');
  return reducedMotionQuery.matches;
}

export function isMobileViewport() {
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 0.02}px)`)
    .matches;
}
